<template>
  <div>
    Root view
  </div>
</template>
